import React, { useMemo } from 'react';
import UnityWebViewer from '../components/UnityWebViewer';

const ANONYMOUS_USER_ID_STORAGE_KEY = "anonymousUserId";

const createAnonymousUserId = () => {
  if (
    typeof window !== "undefined" &&
    typeof window.crypto?.randomUUID === "function"
  ) {
    return window.crypto.randomUUID();
  }

  return `anonymous-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getAnonymousUserId = () => {
  if (typeof window === "undefined") {
    return createAnonymousUserId();
  }

  try {
    const existingUserId = window.localStorage.getItem(
      ANONYMOUS_USER_ID_STORAGE_KEY,
    );

    if (existingUserId) {
      return existingUserId;
    }

    const userId = createAnonymousUserId();
    window.localStorage.setItem(ANONYMOUS_USER_ID_STORAGE_KEY, userId);
    return userId;
  } catch {
    return createAnonymousUserId();
  }
};

const HomePage = () => {
   const anonymousUserId = useMemo(() => getAnonymousUserId(), []);

   const userData = {
      name: "WEB GUEST",
      id: anonymousUserId,
      organizationId: "b69bf0a5-16f5-475c-9e95-50f3e4976e47",
      subscriptionStatus: "free"
    }

return(
  <div className="App">
    <UnityWebViewer
      experienceId="9225a575-dd6c-4774-8ce0-e1a9a778ce11"
      userData={userData}
      completionCtaVariant="default"
      showPlatformSignupCta
    />
  </div>
);
}


export default HomePage;
